export class Survey {
    constructor(_data) {
        this.id = _data.id || 0;
        this.title = _data.title || '';
        this.description = _data.description || '';
        this.building_id = _data.building_id || '';
        this.zone_id = _data.zone_id || '';
        this.pages = _data.pages || [];
        this.trigger = _data.trigger || 'NONE';
    }
}
